<button type="button" class="btn btn-primary navigate-next" [ngClass]="buttonClass" (click)="handleClick()" [disabled]="disabled">
  <span>{{ buttonTextOverride ?? buttonText | translate }}</span>
  <i class="mdi mdi-16px mdi-chevron-right" *ngIf="showIcon"></i>
</button>
